import { SurveyTranslation } from '@surveycake/logic-engine';
import { Theme } from '@surveycake/rc';
import { Wording } from '@surveycake/wording/survey';
import { http } from './http';

let alreadySetVisit = false;

/**
 * To notify server that this survey is visited.
 */
export async function createVisit(svid: string) {
  try {
    if (!alreadySetVisit) {
      const url = http.url.api(`/s/visit/create?${http.query({ svid })}`, 1);
      const res = await http.get(url);
      const { status, errmsg = '' } = await http.handleResponse(res);

      if (!status) {
        throw new Error(errmsg);
      }
      alreadySetVisit = true;
    }
  } catch (error) {
    throw error;
  }
}

/**
 * To get the correct time from server. Avoid from user changing their timezone of computer.
 */
export async function getServerTimeString(svid: string): Promise<string> {
  try {
    const url = http.url.api(`/s/visit/time?${http.query({ svid })}`, 1);
    const res = await http.get(url);
    const { status, data, errmsg = '' } = await http.handleResponse(res);

    if (!status) {
      throw new Error(errmsg);
    }

    return data.time;
  } catch (error) {
    throw error;
  }
}

/**
 * To get the theme data.
 */
export function getTheme(name: string): Promise<Theme> {
  return http
    .get(http.url.assets(`/theme/${name}/theme.json`), { cache: 'no-cache' })
    .then(response => http.handleResponse(response));
}

/**
 * To get the translation data for `LogicEngine`.
 */
export function getTranslation(
  svid: string,
  language: string
): Promise<SurveyTranslation> {
  return http
    .get(http.url.file(`/json/${svid}-${language}.json`), { cache: 'no-cache' })
    .then(response => http.handleResponse(response));
}

/**
 * To get the i18n resources of the specific language.
 */
export function getWording(language: string): Promise<Wording> {
  return http
    .get(http.url.assets(`/wording/${language}/s.json`), { cache: 'no-cache' })
    .then(response => http.handleResponse(response));
}
